import { Table, Modal, Select } from "antd";
import dayjs from "dayjs";
import { useState } from "react";

const PaymentsModal = ({
  isModalOpen = false,
  setIsModalOpen = () => {},
  paymentsList,
  handleUserPayments,
  paymentFilterOptions,
  userId
}) => {
  const [paymentIntent, setPaymentIntent] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState(null);

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const columns = [
    {
      title: "S No.",
      dataIndex: "index",
      key: "index"
    },
    {
      title: "Course",
      dataIndex: "courseName",
      key: "name"
    },
    {
      title: "Batch",
      dataIndex: "batchName",
      key: "batchName"
    },
    {
      title: "Currency",
      dataIndex: "currency",
      key: "currency"
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price"
    },
    {
      title: "Intent",
      dataIndex: "intent",
      key: "intent"
    },
    {
      title: "Payment Status",
      dataIndex: "status",
      key: "status"
    },
    {
      title: "Purchased On",
      dataIndex: "purchasedOn",
      key: "purchasedOn",
      render: (purchasedOn) => dayjs(purchasedOn).format("DD MMM YYYY | HH:mm")
    },
    {
      title: "Razorpay OrderId",
      dataIndex: "razorpayOrderId",
      key: "razorpayOrderId"
    }
  ];

  return (
    <Modal
      title="Payments"
      open={isModalOpen}
      footer={[]}
      width={2000}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <Select
        placeholder="Select Intent"
        style={{ width: "min(200px, 100%)", marginBottom: 10 }}
        onChange={(value) => setPaymentIntent(value)}
      >
        {paymentFilterOptions?.paymentIntents?.map((item) => (
          <Select.Option value={item.label} key={item.key}>
            {item.label}
          </Select.Option>
        ))}
      </Select>
      <Select
        placeholder="Select Status"
        style={{ width: "min(200px, 100%)", marginBottom: 10 }}
        onChange={(value) => setPaymentStatus(value)}
      >
        {paymentFilterOptions?.paymentStatuses?.map((item) => (
          <Select.Option value={item.label} key={item.key}>
            {item.label}
          </Select.Option>
        ))}
      </Select>
      <button
        style={{ marginBottom: 10 }}
        onClick={() => handleUserPayments(userId, paymentIntent, paymentStatus)}
      >
        Submit
      </button>
      <Table
        columns={columns}
        dataSource={paymentsList || []}
        bordered
        pagination={false}
        scroll={{ x: "max-content" }}
      />
    </Modal>
  );
};

export default PaymentsModal;
